import React from 'react';
import ReactModal from 'react-modal';

import CloseIcon from '../icons/CloseIcon';

function Modal({
  visible,
  toggleModal,
  children,
  centered = false,
  whiteOverlay = false,
  blueBackground = false,
}) {
  return (
    <ReactModal
      isOpen={visible}
      onRequestClose={toggleModal}
      className={`modal ${centered ? 'modal--centered' : ''} ${blueBackground ? 'modal--blue' : ''}`}
      overlayClassName={`modal__overlay ${whiteOverlay ? 'modal__overlay--white' : ''}`}
    >
      <button type="button" className="modal__button" onClick={toggleModal}>
        <CloseIcon />
      </button>
      <div className="modal__scroll">
        {children}
      </div>
    </ReactModal>
  );
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/Modal.js